export default __webpack_public_path__ + "static/media/MP_Skills_Situation_02.28034bed.png";